(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-tab-block"] && !Shopify.designMode) return;
  try {
    
    class BrandsTab extends HTMLElement {
        constructor() {
            super();
            this.tabTitle = this.querySelector('.tab-title');
            this.tabContent = this.querySelector('.tab-panel-content');
            const ele = this.querySelectorAll('[tab-title-action]');
            const actionLoadMore = this.querySelectorAll('[data-load-more-block]');
            this.widthWindow = 0;
            if (ele.length) {
                ele.forEach((button) => button.addEventListener('click', this.onActive.bind(this)));
            }
            if (actionLoadMore.length) {
                actionLoadMore.forEach((button) => button.addEventListener('click', this.onLoadMore.bind(this)));
            }
        }

        onActive(e) {
            this.tabTitle.querySelector('.active').classList.remove('active');
            this.tabContent.querySelector('.active').classList.remove('active');
            this.querySelector(e.target.dataset.target).classList.add('active');
            e.target.parentElement.classList.add('active');
        }
        onLoadMore(e) {
            this.resize();
            if (this.widthWindow > 1024) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-lg');
                var _number = e.target.dataset.rowlg;
                var _class = 'hidden-lg';
                
            } else if(this.widthWindow > 551) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-md');
                var _number = 9;
                var _class = 'hidden-md';
            } else {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-sm');
                var _number = 6;
                var _class = 'hidden-sm';
            }
            if (eleHide.length) {
                // let number_show = (eleHide.length > number ? number : eleHide.length);
                if (e.target.classList.contains('more')) {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.remove('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonmore;
                    e.target.classList.remove('more');
                } else {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.add('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonless;
                    e.target.classList.add('more');
                }

                // (eleHide.length > _number ? '' : e.target.classList.add('hidden'));
            }
        }
        resize() {
            this.widthWindow = window.innerWidth;
        }
    }
    customElements.define('brand-tab', BrandsTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-02"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.onScrollHandler = this.onScroll.bind(this);
    this.onResizeHandler = this.onResize.bind(this);
    this.onVisualViewportResizeHandler = this.onVisualViewportResize.bind(this);
    this.onDrawerKeydownHandler = this.onDrawerKeydown.bind(this);

    this.menuScrollY = 0;
    this.wasMenuOpen = false;
    this.isRestoringMenuClose = false;
    this.savedHeaderState = null;

    this.lastMenuOpener = null;
    this.activeDrawer = null;
  }

  connectedCallback() {
    this.section =
      document.getElementById(`shopify-section-${this.dataset.sectionId}`) ||
      document.getElementById('shopify-section-header-02');

    this.header = this.section;
    this.headerParallax = this.section ? this.section.querySelector('.enable_parallax') : null;
    this.headerBottom = this.section ? (this.section.querySelector('.header-bottom')?.clientHeight || 0) : 0;
    this.heightEle = this.headerParallax
      ? this.headerParallax.clientHeight
      : (this.header?.clientHeight || 0);

    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.check = false;
    this.hideOnScroll = this.dataset.hideOnScroll;
    this.isHomepage = this.dataset.isHomepage === 'true';

    window.addEventListener('scroll', this.onScrollHandler, false);
    window.addEventListener('resize', this.onResizeHandler);

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', this.onVisualViewportResizeHandler);
      window.visualViewport.addEventListener('scroll', this.onVisualViewportResizeHandler);
    }

    this.createObserver();
    this.bindMegamenuInvert();
    this.bindMobileDrawerFocusFix();
    this.syncStickyBodyClass();
    this.syncTransparentBodyClass(window.pageYOffset || document.documentElement.scrollTop || 0);
    this.updateRow2Offset();
    this.updateMobileDrawerHeight();

    requestAnimationFrame(() => this.updateMobileDrawerHeight());
    setTimeout(() => this.updateMobileDrawerHeight(), 100);
    setTimeout(() => this.updateMobileDrawerHeight(), 300);

    this.bodyClassObserver = new MutationObserver(() => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      this.syncTransparentBodyClass(scrollTop);
      this.updateMobileDrawerHeight();
    });

    this.bodyClassObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
    window.removeEventListener('resize', this.onResizeHandler);

    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.onVisualViewportResizeHandler);
      window.visualViewport.removeEventListener('scroll', this.onVisualViewportResizeHandler);
    }

    document.removeEventListener('keydown', this.onDrawerKeydownHandler);

    if (this.bodyClassObserver) {
      this.bodyClassObserver.disconnect();
    }

    if (this.menuObserver) {
      this.menuObserver.disconnect();
    }
  }

  onResize() {
    this.headerBottom = this.section ? (this.section.querySelector('.header-bottom')?.clientHeight || 0) : 0;
    this.heightEle = this.headerParallax
      ? this.headerParallax.clientHeight
      : (this.header?.clientHeight || 0);

    this.syncTransparentBodyClass(window.pageYOffset || document.documentElement.scrollTop || 0);
    this.updateRow2Offset();
    this.updateMobileDrawerHeight();
  }

  onVisualViewportResize() {
    this.updateMobileDrawerHeight();
  }

  createObserver() {
    const observer = new IntersectionObserver((entries, obs) => {
      this.headerBounds = entries[0].intersectionRect;
      obs.disconnect();
    });

    observer.observe(this.headerParallax || this.header);
  }

  syncStickyBodyClass() {
    const isSticky = this.section && this.section.classList.contains('shopify-section-header-sticky');
    document.body.classList.toggle('is-header02-sticky', !!isSticky);
  }

  syncTransparentBodyClass(scrollTop) {
    const hasParallax = !!this.headerParallax;
    const isSticky = this.section && this.section.classList.contains('shopify-section-header-sticky');
    const threshold = this.heightEle - this.headerBottom;
    const isTransparent = hasParallax && !isSticky && scrollTop <= threshold && this.isHomepage;

    document.body.classList.toggle('is-header02-transparent', !!isTransparent);

    const isMenuOpen = document.body.classList.contains('menu_open');
    const isMegamenuOpen = document.body.classList.contains('is-header02-megamenu-open');

    if (isMenuOpen || isMegamenuOpen) {
      this.setCartIconColor('#000000');
    } else {
      this.setCartIconColor(isTransparent ? '#ffffff' : '#000000');
    }
  }

  setCartIconColor(color) {
    const cart = this.section ? this.section.querySelector('.header__icon--cart') : null;
    if (!cart) return;

    cart.style.setProperty('color', color, 'important');

    cart.querySelectorAll('svg path, svg line, svg polyline, svg rect, svg circle').forEach((el) => {
      el.style.setProperty('stroke', color, 'important');
      el.style.setProperty('fill', 'none', 'important');
    });

    const bubble = cart.querySelector('.cart-count-bubble');
    if (bubble) {
      if (color === '#ffffff') {
        bubble.style.setProperty('background-color', '#ffffff', 'important');
        bubble.style.setProperty('color', '#000000', 'important');
      } else {
        bubble.style.setProperty('background-color', '#000000', 'important');
        bubble.style.setProperty('color', '#ffffff', 'important');
      }
    }
  }

  bindMegamenuInvert() {
    this.nav = this.section ? this.section.querySelector('[data-navigation]') : null;
    if (!this.nav) return;

    this.megamenuZone = this.section.querySelector('.header-02');
    this.megamenuCloseTimeout = null;

    this.openMegamenuState = (e) => {
      if (window.innerWidth < 1025) return;
      clearTimeout(this.megamenuCloseTimeout);
      document.body.classList.add('is-header02-megamenu-open');
      this.setCartIconColor('#000000');

      if (e && e.target && e.target.setAttribute) {
        e.target.setAttribute('aria-expanded', 'true');
      }
    };

    this.closeMegamenuState = () => {
      if (window.innerWidth < 1025) return;

      this.megamenuCloseTimeout = setTimeout(() => {
        document.body.classList.remove('is-header02-megamenu-open');
        this.desktopMenuItems.forEach((item) => item.setAttribute('aria-expanded', 'false'));

        const isTransparent = document.body.classList.contains('is-header02-transparent');
        this.setCartIconColor(isTransparent ? '#ffffff' : '#000000');
      }, 150);
    };

    this.desktopMenuItems = Array.from(
      this.nav.querySelectorAll('.menu-lv-item.menu-lv-1, .menu-lv-1, .list-menu--inline > li')
    );

    this.desktopMenuItems.forEach((item) => {
      item.setAttribute('aria-expanded', 'false');
      item.addEventListener('mouseenter', this.openMegamenuState);
      item.addEventListener('focusin', this.openMegamenuState);
      item.addEventListener('mouseleave', this.closeMegamenuState);
    });

    if (this.megamenuZone) {
      this.megamenuZone.addEventListener('mouseenter', () => {
        if (window.innerWidth < 1025) return;
        clearTimeout(this.megamenuCloseTimeout);

        const anyHoveredTrigger = this.desktopMenuItems.some((item) => item.matches(':hover'));
        const anyOpenDropdown =
          this.megamenuZone.querySelector('.menu-dropdown:hover, .site-nav-dropdown:hover, .list-menu--disclosure:hover') !== null;

        if (anyHoveredTrigger || anyOpenDropdown) {
          document.body.classList.add('is-header02-megamenu-open');
        }
      });

      this.megamenuZone.addEventListener('mouseleave', this.closeMegamenuState);

      this.megamenuZone.addEventListener('focusout', () => {
        requestAnimationFrame(() => {
          if (!this.megamenuZone.matches(':focus-within')) {
            this.closeMegamenuState();
          }
        });
      });
    }
  }

  storeMenuScrollPosition() {
    this.menuScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  captureHeaderState() {
    if (!this.section) return;

    this.savedHeaderState = {
      sectionHidden: this.section.classList.contains('shopify-section-header-hidden'),
      sectionSticky: this.section.classList.contains('shopify-section-header-sticky'),
      sectionAnimate: this.section.classList.contains('animate'),
      sectionSlideDown: this.section.classList.contains('slide-down'),
      bodySticky: document.body.classList.contains('is-header02-sticky'),
      bodyScrolling: document.body.classList.contains('scrolling'),
      bodyScrollUp: document.body.classList.contains('scroll-up'),
      bodyScrollDown: document.body.classList.contains('scroll-down')
    };
  }

  restoreHeaderState() {
    if (!this.section || !this.savedHeaderState) return;

    const s = this.savedHeaderState;

    this.section.classList.toggle('shopify-section-header-hidden', s.sectionHidden);
    this.section.classList.toggle('shopify-section-header-sticky', s.sectionSticky);
    this.section.classList.toggle('animate', s.sectionAnimate);
    this.section.classList.toggle('slide-down', s.sectionSlideDown);

    document.body.classList.toggle('is-header02-sticky', s.bodySticky);
    document.body.classList.toggle('scrolling', s.bodyScrolling);
    document.body.classList.toggle('scroll-up', s.bodyScrollUp);
    document.body.classList.toggle('scroll-down', s.bodyScrollDown);
  }

  getActiveDrawer() {
    return document.querySelector(
      '.halo-sidebar-left.is-open, .halo-sidebar.halo-sidebar-left.is-open, .menu-drawer[open], .menu-drawer.is-open, .menu-drawer'
    );
  }

  getFocusableElements(container) {
    if (!container) return [];

    return Array.from(
      container.querySelectorAll(
        'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
      )
    ).filter((el) => {
      return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    });
  }

  moveFocusIntoDrawer() {
    const drawer = this.getActiveDrawer();
    if (!drawer) return;

    this.activeDrawer = drawer;

    const focusables = this.getFocusableElements(drawer);
    const closeBtn =
      drawer.querySelector('.menu-drawer__close-button, .close, .close-menu, .icon-close, [data-close-sidebar], [aria-label="Close"], [aria-label="close"]');

    const target = closeBtn || focusables[0];

    if (target) {
      requestAnimationFrame(() => {
        target.focus({ preventScroll: true });
      });
    }
  }

  trapFocusInDrawer(event) {
    if (!document.body.classList.contains('menu_open')) return;

    const drawer = this.activeDrawer || this.getActiveDrawer();
    if (!drawer) return;

    const focusables = this.getFocusableElements(drawer);
    if (!focusables.length) return;

    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    const active = document.activeElement;

    if (event.shiftKey) {
      if (active === first || !drawer.contains(active)) {
        event.preventDefault();
        last.focus({ preventScroll: true });
      }
    } else {
      if (active === last || !drawer.contains(active)) {
        event.preventDefault();
        first.focus({ preventScroll: true });
      }
    }
  }

  onDrawerKeydown(event) {
    if (event.key !== 'Tab') return;
    this.trapFocusInDrawer(event);
  }

  restoreFocusToOpener() {
    if (
      this.lastMenuOpener &&
      typeof this.lastMenuOpener.focus === 'function' &&
      document.contains(this.lastMenuOpener)
    ) {
      this.lastMenuOpener.focus({ preventScroll: true });
    }
  }

  restoreMenuScrollPosition() {
    const targetY = typeof this.menuScrollY === 'number'
      ? this.menuScrollY
      : (window.pageYOffset || document.documentElement.scrollTop || 0);

    this.captureHeaderState();
    this.isRestoringMenuClose = true;

    requestAnimationFrame(() => {
      if (!this.section) {
        this.isRestoringMenuClose = false;
        return;
      }

      this.section.classList.add('header-no-anim');
      this.restoreHeaderState();
      this.syncStickyBodyClass();
      this.updateRow2Offset();
      this.updateMobileDrawerHeight();

      const currentY = window.pageYOffset || document.documentElement.scrollTop || 0;

      if (Math.abs(currentY - targetY) > 2) {
        window.scrollTo(0, targetY);
        this.currentScrollTop = targetY;
      } else {
        this.currentScrollTop = currentY;
      }

      requestAnimationFrame(() => {
        this.syncStickyBodyClass();
        this.updateRow2Offset();
        this.updateMobileDrawerHeight();
        this.section.classList.remove('header-no-anim');
        this.isRestoringMenuClose = false;
      });
    });
  }

  bindMobileDrawerFocusFix() {
    const openButtons = this.section
      ? this.section.querySelectorAll(
          '.mobileMenu-toggle, [aria-controls*="menu"], [data-open-mobile-menu], .icon-hamburger'
        )
      : [];

    openButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.lastMenuOpener = btn;
        this.storeMenuScrollPosition();

        if (window.matchMedia('(pointer: coarse)').matches && document.activeElement === btn) {
          btn.blur();
        }

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (document.body.classList.contains('menu_open')) {
              this.moveFocusIntoDrawer();
            }
          });
        });
      });
    });

    document.addEventListener('click', (event) => {
      const closeTrigger = event.target.closest(
        '.halo-sidebar .close, .halo-sidebar .close-menu, .halo-sidebar .icon-close, .menu-drawer__close-button, .halo-sidebar [data-close-sidebar], .halo-sidebar [aria-label="Close"], .halo-sidebar [aria-label="close"]'
      );

      if (!closeTrigger) return;

      if (window.matchMedia('(pointer: coarse)').matches && document.activeElement === closeTrigger) {
        closeTrigger.blur();
      }
    });

    document.addEventListener('keydown', this.onDrawerKeydownHandler);

    this.menuObserver = new MutationObserver(() => {
      const isMenuOpen = document.body.classList.contains('menu_open');

      if (isMenuOpen && !this.wasMenuOpen) {
        this.storeMenuScrollPosition();
        requestAnimationFrame(() => {
          this.moveFocusIntoDrawer();
        });
      }

      if (!isMenuOpen && this.wasMenuOpen && !this.isRestoringMenuClose) {
        if (document.activeElement && typeof document.activeElement.blur === 'function') {
          document.activeElement.blur();
        }

        this.activeDrawer = null;
        this.restoreMenuScrollPosition();

        requestAnimationFrame(() => {
          this.restoreFocusToOpener();
        });
      }

      this.wasMenuOpen = isMenuOpen;
    });

    this.menuObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  updateMobileDrawerHeight() {
    if (!this.section) return;

    const mobileHeader =
      this.section.querySelector('.header-mobile') ||
      this.section.querySelector('.mobile-header-1') ||
      this.section.querySelector('.header-mobile.mobile-header-1');

    if (!mobileHeader) {
      document.documentElement.style.setProperty('--header-mobile-offset', '79px');
      document.documentElement.style.setProperty('--header-mobile-height', '79px');
      return;
    }

    const rect = mobileHeader.getBoundingClientRect();
    const offset = Math.max(0, Math.round(rect.bottom));
    const height = Math.max(0, Math.round(rect.height));

    document.documentElement.style.setProperty('--header-mobile-offset', offset + 'px');
    document.documentElement.style.setProperty('--header-mobile-height', height + 'px');
  }

  onScroll() {
    if (!this.section) return;

    if (this.isRestoringMenuClose) {
      this.updateMobileDrawerHeight();
      return;
    }

    document.body.classList.add('scrolling');

    if (!this.headerParallax) {
      this.style.height = `${this.section.clientHeight}px`;
    }

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.syncTransparentBodyClass(scrollTop);
    this.updateMobileDrawerHeight();

    if (!this.check || scrollTop === 0) {
      if (
        !document.body.classList.contains('cart-sidebar-show') &&
        !document.body.classList.contains('sticky-search-open')
      ) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.heightEle) {
          if (this.hideOnScroll == 'true') {
            requestAnimationFrame(this.hide.bind(this));
          } else {
            requestAnimationFrame(this.reveal2.bind(this));
          }
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.heightEle) {
          requestAnimationFrame(this.reveal.bind(this));
        } else if (scrollTop - (this.heightEle - this.headerBottom) <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }

        this.toggleRow2(scrollTop > this.heightEle);
        this.check = true;
        this.currentScrollTop = scrollTop;
      }
    } else {
      this.check = false;
    }
  }

  hide() {
    this.section.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.section.classList.remove('animate', 'slide-down');
    document.body.classList.add('scroll-down');
    document.body.classList.remove('scroll-up');
    this.closeMenuDisclosure();
    this.syncStickyBodyClass();
    this.updateRow2Offset();
    this.updateMobileDrawerHeight();
  }

  reveal() {
    this.section.classList.add('shopify-section-header-sticky');
    this.section.classList.remove('shopify-section-header-hidden', 'animate', 'slide-down');
    document.body.classList.add('scroll-up');
    document.body.classList.remove('scroll-down');
    this.syncStickyBodyClass();
    this.updateRow2Offset();
    this.updateMobileDrawerHeight();
  }

  reveal2() {
    this.section.classList.add('shopify-section-header-sticky');
    this.section.classList.remove('shopify-section-header-hidden', 'animate', 'slide-down');
    document.body.classList.add('scroll-up');
    document.body.classList.remove('scroll-down');
    this.syncStickyBodyClass();
    this.updateRow2Offset();
    this.updateMobileDrawerHeight();
  }

  reset() {
    this.section.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate', 'slide-down');
    document.body.classList.remove('scrolling', 'scroll-down', 'scroll-up');
    document.body.classList.remove('is-header02-megamenu-open');
    this.syncStickyBodyClass();
    this.toggleRow2(false);
    this.updateRow2Offset();
    this.updateMobileDrawerHeight();
    this.syncTransparentBodyClass(window.pageYOffset || document.documentElement.scrollTop || 0);
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.section.querySelectorAll('details-disclosure');
    this.disclosures.forEach((d) => d.close());
  }

  toggleRow2(show) {
    const bar = document.querySelector('.header-row2-countdown');
    if (!bar) return;

    if (show) {
      bar.classList.add('row2-visible');
      this.updateRow2Offset();
    } else {
      bar.classList.remove('row2-visible');
      bar.style.top = '-9999px';
    }
  }

  updateRow2Offset() {
    const bar = document.querySelector('.header-row2-countdown');
    if (!bar || !this.section) return;

    const headerEl = this.section.querySelector('header') || this.section;
    const h = headerEl.offsetHeight || 0;

    if (this.section.classList.contains('shopify-section-header-sticky')) {
      bar.style.top = h + 'px';
      document.documentElement.style.setProperty('--header-02-sticky-height', h + 'px');
    } else {
      bar.style.top = '-9999px';
    }
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-03"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-03');
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll
            this.headerHeight = this.header.clientHeight;
            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerHeight) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else if (scrollTop <= this.headerHeight) {
                    requestAnimationFrame(this.reset.bind(this));
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-04"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-04');
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.HeaderAnnouncement = document.getElementById('shopify-section-announcement-bar').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onScroll() {
            this.style.height = `${this.header.clientHeight}px`;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (document.getElementById('shopify-section-announcement-bar') && this.HeaderAnnouncement > 0) {
                var headerHeight = this.header.clientHeight + this.HeaderAnnouncement
            } else {
                var headerHeight = this.header.clientHeight
            }
            if (!this.check) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > headerHeight) {
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > headerHeight) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else if (scrollTop - (headerHeight - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
            if(!$('.header-04').hasClass('style_3')){
                $('.vertical-menu').addClass('hide');
            }
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
            if(!$('.header-04').hasClass('style_3')){
                if ($('.vertical-menu').hasClass('open')) {
                    $('.vertical-menu').removeClass('hide');
                }
            }
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-05"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-05');
            this.header_1 = document.querySelector('.enable_parallax');
            if (this.header_1 != null) {
              this.heightEle = this.header_1.clientHeight;
            } else {
              this.heightEle = this.header.clientHeight;
            }
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
            if (this.header_1 != null) {
                observer.observe(this.header_1);
            } else {
                observer.observe(this.header);
            }
        }

        onScroll() {
            if (this.header_1 == null || this.header_1 == '') 
              this.style.height = `${this.header.clientHeight}px`;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check || scrollTop == 0) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.heightEle) {
                  if (this.header_1 != null) 
                        this.header_1.style.transform = `translateY(-${this.header_1.clientHeight}px)`;
                        if (this.hideOnScroll == 'true') {
                            requestAnimationFrame(this.hide.bind(this));
                        } else {
                            requestAnimationFrame(this.reveal2.bind(this));
                        }
                    
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.heightEle) {
                    requestAnimationFrame(this.reveal.bind(this));
                    if (this.header_1 != null) 
                      this.header_1.style.transform = `translateY(0)`;
                } else if (scrollTop - (this.heightEle - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                    if (this.header_1 != null) 
                        this.header_1.style.transform = `translateY(0)`;
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-06"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-06');
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);
            this.onResizeHandler = this.onResize.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);
            window.addEventListener('resize', this.onResizeHandler);
            
            this.createObserver();
            this.onResizeHandler();
        }
        
        disconnectedCallback() {
            window.removeEventListener('resize', this.onResizeHandler);
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onResize() {
            this.style.height = `${this.querySelector('header.header').clientHeight}px`;
        }
        
        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check) {
                if (window.innerWidth > 1200 && document.querySelector('.layout_search--style2')) {
                    const openDetailsElement = this.querySelector('details[open]');
                    if (openDetailsElement) {
                        const summaryElement = openDetailsElement.querySelector('summary');
                        openDetailsElement.removeAttribute('open');
                        summaryElement.focus();
                        document.body.classList.remove('open_search');
                    }
                }
                if (!document.body.classList.contains('cart-sidebar-show') && 
                    !document.body.classList.contains('sticky-search-open')) {
                    if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight) {
                        if (this.hideOnScroll == 'true') {
                            requestAnimationFrame(this.hide.bind(this));
                        } else {
                            requestAnimationFrame(this.reveal2.bind(this));
                        }
                    } else if (scrollTop < this.currentScrollTop && scrollTop > this.header.clientHeight) {
                        requestAnimationFrame(this.reveal.bind(this));
                    } else if (scrollTop - (this.header.clientHeight - this.headerBottom) <= this.headerBounds.top) {
                        requestAnimationFrame(this.reset.bind(this));
                    }
                    this.check = true;
                    this.currentScrollTop = scrollTop;
                }
            } else {
                this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-07"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-07');
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);
            this.onResizeHandler = this.onResize.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);
            window.addEventListener('resize', this.onResizeHandler);
            
            this.createObserver();
            this.onResizeHandler();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
            window.removeEventListener('resize', this.onResizeHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onResize() {
            this.style.height = `${this.querySelector('header.header').clientHeight}px`;
        }

        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check) {
                if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                    if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight) {
                        if (this.hideOnScroll == 'true') {
                            requestAnimationFrame(this.hide.bind(this));
                        } else {
                            requestAnimationFrame(this.reveal2.bind(this));
                        }
                    } else if (scrollTop < this.currentScrollTop && scrollTop > this.header.clientHeight) {
                        requestAnimationFrame(this.reveal.bind(this));
                    } else if (scrollTop - (this.header.clientHeight - this.headerBottom) <= this.headerBounds.top) {
                        requestAnimationFrame(this.reset.bind(this));
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
                }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-08"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-08');
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onScroll() {
            this.style.height = `${this.header.clientHeight}px`;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else if (scrollTop - (this.header.clientHeight - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-09"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-09');
            this.heightEle = this.header.clientHeight;
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
            observer.observe(this.header);
        }

        onScroll() {
            this.style.height = `${this.header.clientHeight}px`;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else if (scrollTop - (this.header.clientHeight - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-10"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-10');
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onScroll() {
            this.style.height = `${this.header.clientHeight}px`;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else if (scrollTop - (this.header.clientHeight - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-11"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-11');
            this.heightEle = this.header.clientHeight;
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
            observer.observe(this.header);
        }

        onScroll() {
            this.style.height = `${this.header.clientHeight}px`;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else if (scrollTop - (this.header.clientHeight - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-12"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-12');
            this.heightEle = this.header.clientHeight;
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll
            
            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
            if (this.header_1 != null) {
                observer.observe(this.header_1);
            } else {
                observer.observe(this.header);
            }
        }

        onScroll() {
            if (this.header_1 == null || this.header_1 == '') 
              this.style.height = `${this.header.clientHeight}px`;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check || scrollTop == 0) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.heightEle) {
                  if (this.header_1 != null) 
                      this.header_1.style.transform = `translateY(-${this.header_1.clientHeight}px)`;
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.heightEle) {
                    requestAnimationFrame(this.reveal.bind(this));
                    if (this.header_1 != null) 
                      this.header_1.style.transform = `translateY(0)`;
                } else if (scrollTop - (this.heightEle - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                    if (this.header_1 != null) 
                        this.header_1.style.transform = `translateY(0)`;
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header');
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);
            this.onResizeHandler = this.onResize.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);
            window.addEventListener('resize', this.onResizeHandler);
            
            this.createObserver();
            this.onResizeHandler();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
            window.removeEventListener('resize', this.onResizeHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onResize() {
            this.style.height = `${this.querySelector('header.header').clientHeight}px`;
        }
        
        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else if (scrollTop - (this.header.clientHeight - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
